import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {o as objectWithoutPropertiesLoose, _ as _extends_1} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {c as capitalize} from "../../common/capitalize-0607751a.js";
import {T as Typography} from "../../common/index-6e985b71.js";
import {F as FormControlContext_1, u as useFormControl_1} from "../../common/useFormControl-9e2a3560.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
var inputAdornmentClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getInputAdornmentUtilityClass = getInputAdornmentUtilityClass;
  function getInputAdornmentUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiInputAdornment", slot);
  }
  const inputAdornmentClasses = (0, core.generateUtilityClasses)("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
  var _default = inputAdornmentClasses;
  exports.default = _default;
});
var InputAdornment_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var _extends2 = interopRequireDefault(_extends_1);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _capitalize = interopRequireDefault(capitalize);
  var _Typography = interopRequireDefault(Typography);
  var _FormControlContext = interopRequireDefault(FormControlContext_1);
  var _useFormControl = interopRequireDefault(useFormControl_1);
  var _styled = interopRequireDefault(styled_1);
  var _inputAdornmentClasses = _interopRequireWildcard(inputAdornmentClasses_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  const _excluded = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const overridesResolver = (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`position${(0, _capitalize.default)(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
  };
  const useUtilityClasses = (ownerState) => {
    const {
      classes,
      disablePointerEvents,
      hiddenLabel,
      position,
      size,
      variant
    } = ownerState;
    const slots = {
      root: ["root", disablePointerEvents && "disablePointerEvents", position && `position${(0, _capitalize.default)(position)}`, variant, hiddenLabel && "hiddenLabel", size && `size${(0, _capitalize.default)(size)}`]
    };
    return (0, core.unstable_composeClasses)(slots, _inputAdornmentClasses.getInputAdornmentUtilityClass, classes);
  };
  const InputAdornmentRoot = (0, _styled.default)("div", {
    name: "MuiInputAdornment",
    slot: "Root",
    overridesResolver
  })(({
    theme,
    ownerState
  }) => (0, _extends2.default)({
    display: "flex",
    height: "0.01em",
    maxHeight: "2em",
    alignItems: "center",
    whiteSpace: "nowrap",
    color: theme.palette.action.active
  }, ownerState.variant === "filled" && {
    [`&.${_inputAdornmentClasses.default.positionStart}&:not(.${_inputAdornmentClasses.default.hiddenLabel})`]: {
      marginTop: 16
    }
  }, ownerState.position === "start" && {
    marginRight: 8
  }, ownerState.position === "end" && {
    marginLeft: 8
  }, ownerState.disablePointerEvents === true && {
    pointerEvents: "none"
  }));
  const InputAdornment2 = /* @__PURE__ */ React$1.forwardRef(function InputAdornment3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiInputAdornment"
    });
    const {
      children,
      className,
      component = "div",
      disablePointerEvents = false,
      disableTypography = false,
      position,
      variant: variantProp
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const muiFormControl = (0, _useFormControl.default)() || {};
    let variant = variantProp;
    if (variantProp && muiFormControl.variant)
      ;
    if (muiFormControl && !variant) {
      variant = muiFormControl.variant;
    }
    const ownerState = (0, _extends2.default)({}, props, {
      hiddenLabel: muiFormControl.hiddenLabel,
      size: muiFormControl.size,
      disablePointerEvents,
      position,
      variant
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(_FormControlContext.default.Provider, {
      value: null,
      children: /* @__PURE__ */ (0, _jsxRuntime.jsx)(InputAdornmentRoot, (0, _extends2.default)({
        as: component,
        ownerState,
        className: (0, _clsx.default)(classes.root, className),
        ref
      }, other, {
        children: typeof children === "string" && !disableTypography ? /* @__PURE__ */ (0, _jsxRuntime.jsx)(_Typography.default, {
          color: "text.secondary",
          children
        }) : /* @__PURE__ */ (0, _jsxRuntime.jsxs)(React$1.Fragment, {
          children: [position === "start" ? /* @__PURE__ */ (0, _jsxRuntime.jsx)("span", {
            className: "notranslate",
            dangerouslySetInnerHTML: {
              __html: "&#8203;"
            }
          }) : null, children]
        })
      }))
    });
  });
  var _default = InputAdornment2;
  exports.default = _default;
});
var InputAdornment = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    inputAdornmentClasses: true
  };
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _InputAdornment.default;
    }
  });
  Object.defineProperty(exports, "inputAdornmentClasses", {
    enumerable: true,
    get: function() {
      return _inputAdornmentClasses.default;
    }
  });
  var _InputAdornment = interopRequireDefault(InputAdornment_1);
  var _inputAdornmentClasses = _interopRequireWildcard(inputAdornmentClasses_1);
  Object.keys(_inputAdornmentClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _inputAdornmentClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _inputAdornmentClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(InputAdornment);
export default __pika_web_default_export_for_treeshaking__;
